import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

// noinspection JSUnresolvedReference
export const Marker = styled.div`
    background-color: ${(props) => props.backgroundColor};
    padding: 0.1rem 0.3rem;
    font-size: 0.8rem;
    color: ${ThemeColors.white};
    border-radius: 0.3rem;
    cursor: default;
`
